<template>
  <BlocksCard>
    <h2 class="__heading">
      Location
    </h2>
    <!-- Listing Map -->
    <client-only>
      <CommonMapLocation :height="400" :markers="mapMarkers" should-center-to-marker :zoom-level="12" />
    </client-only>

    <div v-if="listingOrDevelopment.addressOverride || listingOrDevelopment.address?.formattedAddress" class="address-wrapper">
      Address: {{ listingOrDevelopment.addressOverride || listingOrDevelopment.address?.formattedAddress }}
    </div>
  </BlocksCard>
</template>

<script lang="ts" setup>
// PROPS Definitions
//----------------------------------------------------------------------------------------------------------------------
import {Listing} from '~/@types/listing';
import {Ref} from 'vue';
import {Address} from '~/@types/common';
import {Development} from '~/@types/development';

const props = defineProps({
  listingOrDevelopment: {
    type: Object as PropType<Listing | Development>,
    required: true,
  },
});

// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const mapMarkers: Ref<any[]> = ref([]);

/**
 * @_MOUNTED Hook
 */
onMounted(() => {
  initMapMarker();
});

/**
 * Init map marker
 */
function initMapMarker () {
  if (props.listingOrDevelopment && props.listingOrDevelopment.address && window && window.google) {
    mapMarkers.value = [{
      id: props.listingOrDevelopment.slug,
      position:new google.maps.LatLng((props.listingOrDevelopment.address as Address).latitude, (props.listingOrDevelopment.address as Address).longitude),
      title: props.listingOrDevelopment.name,
    }];
  } else if (!props.listingOrDevelopment) {
    setTimeout(() => {
      initMapMarker();
    }, 500);
  }
}
</script>

<style scoped lang="scss">
.address-wrapper {
  margin-top: 1rem;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
</style>
